import React, { useState } from 'react';
import { Input } from '@arco-design/web-react';
import { EditorActionsManager, UpdateDataAction, VirtualRootComponent } from '@easytwin/runtime';
import { message } from '@easyv/react-components';
import { CollapseBox } from '@/UIGenerator';
import { ImmerFormItem } from '@/UIGenerator/uicomponents/ImmerFormItem';
import { deepClone, isNil } from '@/utils';
import { AttrTag } from './AttrTag';

interface CustomAttributeKeyFormProps {
  allAttributes: string[];
  comp: VirtualRootComponent;
}
export default function CustomAttributeKeyForm({
  allAttributes,
  comp,
}: CustomAttributeKeyFormProps) {
  const [inputKey, setInputKey] = useState('');
  const [editingKey, setEditingKey] = useState<string>();

  const onAddCustomAttributeKey = (name: string) => {
    const data = deepClone(comp._data);
    for (const child of data.children) {
      if (!Object.prototype.hasOwnProperty.call(child.customAttribute, name)) {
        child.customAttribute[name] = '';
      }
    }
    const editorActionManager = comp.engine.getManager(EditorActionsManager);
    editorActionManager.execute(new UpdateDataAction(comp, data));
  };

  const onRemoveCustomAttributeKey = (key: string) => {
    if (isNil(comp)) {
      return;
    }

    const data = deepClone(comp._data);
    for (const child of data.children) {
      if (Object.prototype.hasOwnProperty.call(child.customAttribute, key)) {
        delete child.customAttribute[key];
      }
    }
    const editorActionManager = comp.engine.getManager(EditorActionsManager);
    editorActionManager.execute(new UpdateDataAction(comp, data));
  };

  const onRenameEnd = (oldKey: string, newKey: string) => {
    if (isNil(comp)) {
      return;
    }
    if (newKey === '' || oldKey === newKey) {
      setEditingKey(undefined);
      return;
    }
    const data = deepClone(comp._data);

    for (const child of data.children) {
      let oldValue = '';
      if (Object.prototype.hasOwnProperty.call(child.customAttribute, oldKey)) {
        oldValue = child.customAttribute[oldKey];
        delete child.customAttribute[oldKey];
      }
      child.customAttribute[newKey] = oldValue;
    }
    const editorActionManager = comp.engine.getManager(EditorActionsManager);
    editorActionManager.execute(new UpdateDataAction(comp, data));
    setEditingKey(undefined);
  };

  return (
    <>
      <CollapseBox type='area' showDivider noStyle disable title='自定义属性字段编辑'>
        <div className='py-1'>
          <ImmerFormItem label='字段名称'>
            <Input
              autoComplete='off'
              size='small'
              className='w-full'
              placeholder='按回车添加字段'
              value={inputKey}
              onChange={(e) => {
                setInputKey(e);
              }}
              onPressEnter={(e) => {
                const v = e.target.value;
                if (v === '') return;

                const lowerV = (v as string).toLocaleLowerCase();
                const lowerAllAttributes = allAttributes.map((a) => a.toLocaleLowerCase());
                if (lowerAllAttributes.includes(lowerV)) {
                  message.error('自定义属性名不可重复');
                  return;
                }

                onAddCustomAttributeKey(v);
                setInputKey('');
              }}
              onBlur={() => {
                setInputKey('');
              }}
            />
          </ImmerFormItem>

          {allAttributes.length > 0 && (
            <ImmerFormItem>
              <div className='w-full h-min flex flex-wrap gap-x-2 gap-y-2'>
                {allAttributes.map((a) => (
                  <AttrTag
                    key={a}
                    id={a}
                    name={a}
                    editingKey={editingKey}
                    onDelete={onRemoveCustomAttributeKey}
                    onRenameStart={(id) => {
                      setEditingKey(id);
                    }}
                    onRenameEnd={onRenameEnd}
                  />
                ))}
              </div>
            </ImmerFormItem>
          )}
        </div>
      </CollapseBox>
    </>
  );
}
